import Model from '@/store/plugins/orm/Model'

export class OrderItemComment extends Model {
    static get entity() {
        return 'order_item_comments';
    }

    static fields() {
        return {
            id: this.attr(null),
            comment: this.attr(null),
        };
    }
}

export default OrderItemComment
